export type UseDescriptionProps = {
  enabled: boolean;
  description?: string;
}

export function useDescription({ enabled, description }: UseDescriptionProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      {description && <meta key='description' name='description' content={description} />}
    </>
  )
}